import styled from 'styled-components'
import { Border, Colors, Spacing, Typography } from '../../../styles'
import { icons } from '../../../styles/images'
import { TOverviewView } from '../../../utils/types'
import { Icon } from '../../atoms/Icon'
import { Bold } from '../../atoms/typography/Typography'

const EmptyListMessageContainer = styled.div`
    display: flex;
    ${Typography.body.small};
    color: ${Colors.text.muted};
    align-items: center;
    gap: ${Spacing._12};
    justify-content: center;
    border: ${Border.stroke.medium} dashed ${Colors.background.border};
    border-radius: ${Border.radius.medium};
    padding: ${Spacing._16};
    background-color: ${Colors.background.panel};
`

const emptyListMessage = (list: TOverviewView) => {
    switch (list.type) {
        case 'task_section':
            return `Create new tasks to see them here.`
        case 'meeting_preparation':
            return 'Tasks will appear here when you have upcoming meetings.'
        case 'due_today':
            return 'Tasks which are due today will appear here.'
        default:
            return ''
    }
}

interface EmptyListMessageProps {
    list: TOverviewView
}

const EmptyListMessage = ({ list }: EmptyListMessageProps) => {
    return (
        <EmptyListMessageContainer>
            <Icon icon={icons.check} color="gray" />
            <span>
                <Bold>{list.name}</Bold> is empty. {emptyListMessage(list)}
            </span>
        </EmptyListMessageContainer>
    )
}

export default EmptyListMessage
